// TODO: could be nice to clean up the colors so they are easier/consistent to reference
// in storybook, less, and typescript.

export enum SemanticColorEnum {
  Grey = "GREY",
  Success = "SUCCESS",
  Warning = "WARNING",
  Danger = "DANGER",
  Info = "INFO",
  Accent = "ACCENT",
  Promotion = "PROMOTION",
}

export type SemanticColor =
  | "grey"
  | "success"
  | "warning"
  | "danger"
  | "info"
  | "accent"
  | "promotion";

/** Matches PastelColor on BE */
export enum PastelColor {
  Slate = "SLATE",
  Red = "RED",
  Pomegranate = "POMEGRANATE",
  Orange = "ORANGE",
  Amber = "AMBER",
  Yellow = "YELLOW",
  Lime = "LIME",
  Green = "GREEN",
  Emerald = "EMERALD",
  Teal = "TEAL",
  Cyan = "CYAN",
  Sky = "SKY",
  Blue = "BLUE",
  Indigo = "INDIGO",
  Violet = "VIOLET",
  Purple = "PURPLE",
  Fuchsia = "FUCHSIA",
  Pink = "PINK",
  Watermelon = "WATERMELON",
  Rose = "ROSE",
}

export enum VividColor {
  CyberYellow = "CYBER_YELLOW",
  MikadoYellow = "MIKADO_YELLOW",
  PhilippineOrange = "PHILIPPINE_ORANGE",
  CoralRed = "CORAL_RED",
  DeepLilac = "DEEP_LILAC",
  SteelPink = "STEEL_PINK",
  Fuchsi = "FUCHSI",
  ElectricPink = "ELECTRIC_PINK",
  VeryLightBlue = "VERY_LIGHT_BLUE",
  HanBlue = "HAN_BLUE",
  CrayolaBlue = "CRAYOLA_BLUE",
  PictonBlue = "PICTON_BLUE",
  DarkTurquoise = "DARK_TURQUOISE",
  JuneBud = "JUNE_BUD",
  Kiwi = "KIWI",
  VividMalachite = "VIVID_MALACHITE",
  RobinEggBlue = "ROBIN_EGG_BLUE",
  TiffanyBlue = "TIFFANY_BLUE",
}
